import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import { IconAncap } from 'src/general/Icons/IconAncap';
import { IconCalendar } from 'src/general/Icons/IconCalendar';
import { IconCalendarWithTick } from 'src/general/Icons/IconCalendarWithTick';
import { IconColour } from 'src/general/Icons/IconColour';
import { IconDriveType } from 'src/general/Icons/IconDriveType';
import { IconEngine } from 'src/general/Icons/IconEngine';
import { IconEnginePower } from 'src/general/Icons/IconEnginePower';
import { IconFuelConsumption } from 'src/general/Icons/IconFuelConsumption';
import { IconNumberOfKeys } from 'src/general/Icons/IconNumberOfKeys';
import { IconOdometer } from 'src/general/Icons/IconOdometer';
import { IconPetrol } from 'src/general/Icons/IconPetrol';
import { IconSeats } from 'src/general/Icons/IconSeats';
import { IconSpanner } from 'src/general/Icons/IconSpanner';
import { IconTransmission } from 'src/general/Icons/IconTransmission';
import { IconVIN } from 'src/general/Icons/IconVIN';

import { KEY_ITEMS } from './CarKeyInformation.type';

interface Item {
  key: KEY_ITEMS;
  value: string;
}

interface Props {
  items: Item[];
}

type KeyItemProps = {
  [key in KEY_ITEMS]: {
    icon: ReactNode;
    label: string;
  };
};

const keyItem: KeyItemProps = {
  [KEY_ITEMS.KILOMETERS]: {
    icon: <IconOdometer size={20} />,
    label: 'Kilometres',
  },
  [KEY_ITEMS.COMPLIANCE_YEAR]: {
    icon: <IconCalendarWithTick size={20} />,
    label: 'Compliance year',
  },
  [KEY_ITEMS.BUILD_YEAR]: {
    icon: <IconCalendar size={20} />,
    label: 'Build year',
  },
  [KEY_ITEMS.ENGINE_SIZE]: {
    icon: <IconEngine size={20} />,
    label: 'Engine',
  },
  [KEY_ITEMS.FUEL_TYPE]: {
    icon: <IconPetrol size={20} />,
    label: 'Fuel type',
  },
  [KEY_ITEMS.TRANSMISSION]: {
    icon: <IconTransmission size={20} />,
    label: 'Drivetrain',
  },
  [KEY_ITEMS.DRIVE_TYPE]: {
    icon: <IconDriveType size={20} />,
    label: 'Drive type',
  },
  [KEY_ITEMS.SEATS]: {
    icon: <IconSeats size={20} />,
    label: 'Seats',
  },
  [KEY_ITEMS.LAST_SERVICE_DATE]: {
    icon: <IconSpanner size={20} />,
    label: 'Last service date',
  },
  [KEY_ITEMS.VIN_NUMBER]: {
    icon: <IconVIN size={20} />,
    label: 'VIN',
  },
  [KEY_ITEMS.FUEL_CONSUMPTION]: {
    icon: <IconFuelConsumption size={20} />,
    label: 'Fuel consumption',
  },
  [KEY_ITEMS.ANCAP_SAFETY_RATING]: {
    icon: <IconAncap size={20} />,
    label: 'ANCAP safety rating',
  },
  [KEY_ITEMS.KEYS]: {
    icon: <IconNumberOfKeys size={20} />,
    label: 'Number of keys',
  },
  [KEY_ITEMS.EXTERIOR_COLOR]: {
    icon: <IconColour size={20} />,
    label: 'Exterior colour',
  },
  [KEY_ITEMS.ENGINE_POWER]: {
    icon: <IconEnginePower size={20} />,
    label: 'Engine power',
  },
};

export const CarKeyInformation: FC<Props> = ({ items }) => (
  <div className="grid grid-cols-2 gap-4 smp:grid-cols-3">
    {items.length !== 0 &&
      items.map(({ value, key }) => (
        <div
          className={clsx('flex gap-4', {
            ['col-span-2']: key === KEY_ITEMS.VIN_NUMBER,
          })}
          key={key}
        >
          {keyItem[key].icon}
          <dl>
            <dt className="c-fs-body2 text-tex-def-tie2">{keyItem[key].label}</dt>
            <dd className="c-fs-body1" data-testid={`CarKeyInformation-component-${key}-info`}>
              {value}
            </dd>
          </dl>
        </div>
      ))}
  </div>
);
